
module.exports = {
    consumerInfo: require('./consumerInfoWidgetConfig'),
    operatorAlerts: require('./operatorAlertsWidgetConfig'),
    visitInfo: require('./visitInfoWidgetConfig')
};
